import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Index } from './pages/Index';
import { SiteTextProvider } from './lib/SiteTextContext';
import { SiteImagesProvider } from './lib/SiteImagesContext';
import './styles.css';

// The admin area is only used at /admin — code-split it so the public
// landing page never downloads its (heavier) editor bundle.
const AdminPage = lazy(() =>
  import('./pages/AdminPage').then((m) => ({ default: m.AdminPage }))
);

export function App() {
  return (
    <SiteTextProvider>
      <SiteImagesProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route
            path="/admin"
            element={
              <Suspense fallback={<div className="min-h-screen bg-white" />}>
                <AdminPage />
              </Suspense>
            }
          />
          <Route path="*" element={<Index />} />
        </Routes>
      </BrowserRouter>
      </SiteImagesProvider>
    </SiteTextProvider>
  );
}

export default App;
